import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconTemplate(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M3 4a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4Zm8 15V5H5v14h6Zm2-10h6V5h-6v4Zm0 10h6v-8h-6v8Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
